import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=0437f8c6&scoped=true"
import script from "./Roster.vue?vue&type=script&lang=js"
export * from "./Roster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0437f8c6",
  null
  
)

export default component.exports